import type { PiIconName } from '@uiKit/elements/PiIcon.vue'

// Amenity / highlight icons arrive as free-text keywords ("pool",
// "trending_up") or, once the admin upload ships, as image URLs. URLs render
// as images; keywords map onto the closest kit icon by substring.

export const isIconUrl = (icon: string): boolean =>
  /^(https?:)?\/\//.test(icon) || icon.startsWith('/')

const KEYWORD_ICONS: [RegExp, PiIconName][] = [
  [/trend|growth|apprec|chart/i, 'chart-bar'],
  [/cctv|camera|surveil/i, 'eye'],
  [/secur|shield|block|safe|guard/i, 'shield'],
  [/elevator|lift/i, 'building'],
  [/group|people|investor|user|communit/i, 'users'],
  [/income|quarter|month|calendar|schedule|gallery|time|clock/i, 'clock'],
  [/managed|check|verified|done/i, 'check'],
  [/wifi|internet/i, 'wifi'],
  [/shop|market|mall|retail|cart/i, 'shopping-bag'],
  [/parking|garage|car/i, 'map-marker'],
  [/pool|swim|beach|sun|garden|park|bbq|grill|outdoor/i, 'sun'],
  [/gym|fitness|sport|play|court/i, 'users'],
  [/concierge|lobby|home|residen/i, 'home'],
  [/lock|access|key/i, 'lock'],
]

/** Kit icon for a keyword; `fallback` when nothing matches. */
export const iconForKeyword = (
  keyword: string,
  fallback: PiIconName = 'check-circle',
): PiIconName => KEYWORD_ICONS.find(([pattern]) => pattern.test(keyword))?.[1] ?? fallback
